import { BaseComponent2 } from '../../_common/client/base-component2';
import { initializeExpandButton } from './helper/initialize-expand-button';
import { initializeSubheading } from './helper/initialize-subheading';
import { trackOnNextPageImpression } from '@otto-ec/tracking-bct';

export class ShortInfoComponent extends BaseComponent2 {
    public rootSelector = '.js_pdp_short-info';

    public async init(): Promise<void> {
        if (!this.isPresent()) return;
        initializeSubheading(this.getRootElement());
        initializeExpandButton(this.getRootElement());
        this.initializeBrandLinkTracking();
    }

    private initializeBrandLinkTracking() {
        const brandLinkElement = this.findBrandLinkElement();
        brandLinkElement?.addEventListener('click', () => {
            this.trackBrandLinkClickOnNextPI(brandLinkElement);
        });
    }

    private trackBrandLinkClickOnNextPI(brandLinkElement: HTMLElement) {
        if (brandLinkElement.dataset.brandName !== undefined) {
            trackOnNextPageImpression({
                product_BrandLogo: ['clicked_top'],
                'wk.product_BrandLogoClicked': [brandLinkElement.dataset.brandName],
            });
        } else {
            trackOnNextPageImpression({
                product_BrandLogo: ['clicked_top'],
            });
        }
    }

    private findBrandLinkElement() {
        return this.getRootElement().querySelector<HTMLElement>('.js_pdp_short-info__brand-link');
    }
}
